<script>
	import { store } from "../store.js";
	import ToolbalPrimary from "./ToolbalPrimary.svelte";
	import ToolbarSecondary from "./ToolbarSecondary.svelte";
	import ToolbarSecondaryPanier from "./ToolbarSecondaryPanier.svelte";
	import CategoriesArticles from "./CategoriesArticles.svelte";
	import CategoriesFormations from "./CategoriesFormations.svelte";
	import CategoriesEvenements from "./CategoriesEvenements.svelte";
	import Seasons from "./Seasons.svelte";
	import TypesProduction from "./TypesProduction.svelte";
	import MapMode from "./MapMode.svelte";
	import Mode from "./Mode.svelte";
</script>

<!-- <div>
	{JSON.stringify($store.options[$$props.id].filtresParDefaut.type_contenus)}
	{JSON.stringify($store.options[$$props.id])}
</div> -->
<div class="cs_toolbar">
	{#if $store.options[$$props.id].masquer_filtres_primaires != 1 && $store.options[$$props.id].filtres_primaires == "types_contenus"}
		<ToolbalPrimary id={$$props.id} />
	{/if}

	{#if $store.options[$$props.id].masquer_filtres_primaires != 1 && $store.options[$$props.id].filtres_primaires == "categories_articles"}
		<CategoriesArticles id={$$props.id} />
	{/if}
	{#if $store.options[$$props.id].masquer_filtres_primaires != 1 && $store.options[$$props.id].filtres_primaires == "saisons"}
		<Seasons id={$$props.id} />
	{/if}
	{#if $store.options[$$props.id].masquer_filtres_primaires != 1 && $store.options[$$props.id].filtres_primaires == "type_production"}
		<TypesProduction id={$$props.id} />
	{/if}

	{#if $store.options[$$props.id].masquer_filtres_primaires != 1 && $store.options[$$props.id].filtres_primaires == "categories_formations"}
		<CategoriesFormations id={$$props.id} />
	{/if}

	{#if $store.options[$$props.id].masquer_filtres_primaires != 1 && $store.options[$$props.id].filtres_primaires == "categories_evenements"}
		<CategoriesEvenements id={$$props.id} />
	{/if}

	{#if $store.options[$$props.id].filtres_primaires != "type_production" && $store.options[$$props.id].masquer_filtres_secondaires != 1}
		{#if $$props.type_contenus == "panier"}
			<ToolbarSecondaryPanier
				id={$$props.id}
				masquer_mode_liste={$$props.masquer_mode_liste}
			/>
		{:else}
			<ToolbarSecondary
				id={$$props.id}
				masquer_mode_liste={$$props.masquer_mode_liste}
			/>
		{/if}
	{/if}
	{#if $store.options[$$props.id].filtres_primaires == "type_production"}
		<MapMode id={$$props.id} />
	{/if}
</div>
